<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--full-page">
    <!-- <div class="row">
      <div class="">1</div>
      <div class=""><router-view></router-view></div>
    </div> -->
    <!-- <template v-if="isDesktop">
      <span class="title-video"></span>
      <div class="video-back"></div>
      <div class="w-full h-100 video-container">
        <video autoplay muted loop>
          <source src="@/assets/video/video_safras.mp4" type="video/mp4" />
        </video>
      </div>
    </template> -->
    <router-view></router-view>
    <div class="corner-ribbon top-left sticky red" v-if="!isProduction">{{bannerValue}}</div>
  </div>
</template>


<script>
  import AppConstants from '../../appConstants';
  import checkDeviceTypeHelper from '../../helpers/check-device-type-helper';
  
  export default {
    computed: {
      isDesktop() {
        return this.$store.state.isDesktop;
      },
      isProduction() {
        return this.$store.state.isProduction;
      },
      bannerValue() {
        if (this.$config.api_url.indexOf("dev-plataforma") > 0) {
          return "DEV";
        } else if (this.$config.api_url.indexOf("ctdevwebbackend") > 0) {
          return "CT";
        } else {
          return "DEMO";
        }
      },
    },
    created() {
      this.$store.commit("UPDATE_IS_PRODUCTION", window.location.href.indexOf(this.$config.URL_PRODUCTION) === 0);
      // this.$store.commit("UPDATE_DEVICE_IS_DESKTOP", checkDeviceTypeHelper.isMobileOrDesktop() === AppConstants.DEVICE_TYPE_DESKTOP);
    },
    mounted() {
      
      }
  }
</script>
